import type { SeriesOptions } from 'components/common-form/sidePanel/backTest/useBackTestOptions';
import type { DateCalculation } from 'components/shared/DatePicker/utils';
import { addYears } from 'date-fns';
import { range } from 'lodash-es';
import { useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { TranslatableContent } from 'utils/intl';
export const INITIAL_QUOTE_LABEL = 'A';
export const SECOND_QUOTE_LABEL = 'B';

const createYearPreset =
  (yearDelta: number): DateCalculation =>
  (today: Date) =>
    addYears(today, yearDelta);
export const datePresets: DateCalculation[] = range(1, 10).map(i => createYearPreset(i * -1));
export const datePresetsTranslations: TranslatableContent[] = range(1, 10).map(i => ({
  id: 'date.presets.yearsAgo',
  values: { years: i },
}));

export type ChartProps<T> = SeriesOptions<T> & {
  hasCopyToClipBoard?: boolean;
  hasErrorForInitialQuoteId: boolean;
  hasErrorForSecondQuoteId: boolean;
};
export const useRunTestCb = (runTest: () => void) =>
  useCallback(
    (mode: string) => {
      logAnalytics.trackEvent('Backtest', 'Run backtest', mode);
      runTest();
    },
    [runTest],
  );
